import React from 'react';
import { useForm } from 'react-hook-form';

import Page from '@lwt-helix/page';
import { Button } from '@lwt-helix/buttons';
import { authServiceApiFactory } from '../../auth/authServiceApiFactory';
import { useServiceApi } from '../../hooks/services';
import { loggingOut, logoutFailed, logoutSuccess } from '../../actions/AuthActions';
import { useDispatch } from 'react-redux';
import Routes from '../../constants/Routes';
import * as PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { getUserFromToken } from '../../functions/AuthenticationFunctions';

const InactiveUserRedirect = props => {
    const { handleSubmit } = useForm();
    const authServiceApi = useServiceApi(authServiceApiFactory);
    const dispatch = useDispatch();
    const { history } = props;

    const onSubmit = async () => {
        const user = getUserFromToken();

        if (user?.isInternal) {
            history.push(Routes.AUTH_LOGOUT);
        } else {
            dispatch(loggingOut());
            authServiceApi.logout().then(response => {
                if (!response.error) {
                    dispatch(logoutSuccess());
                    history.push(Routes.LOGOUT);
                } else {
                    dispatch(logoutFailed(response.error));
                }
            });
        }
    };

    return (<>
        <Page fluid hero dataLwtId="inactive-user-landing-page">
            <form
                className="mx-auto my-6 rounded card-raised p-6 card card-body"
                style={{ minWidth: '50vw', width: '300px' }}
                onSubmit={handleSubmit(onSubmit)}
            >
                <img className="mx-auto mb-3" src="https://assets.lwolf.com/img/lw-logo-dark.svg" alt="Lone Wolf"
                    height="90" />
                <h3 className="w-100 text-center">
                    You have attempted to login with an inactive user. Please return to the login screen.
                </h3>
                <hr className="my-4 border-top" />

                <Button
                    color="primary"
                    type="submit"
                    style={{ width: '100%' }}
                    dataLwtId="inactive-user-redirect-button"
                >
                    Return to login screen
                </Button>
            </form>
        </Page>
    </>);
};

InactiveUserRedirect.propTypes = {
    history: PropTypes.object,
    onSuccess: PropTypes.func
};

export default withRouter(InactiveUserRedirect);